<template>
  <div style="cursor:pointer" @mouseenter="showSubButton" @mouseleave="closeSubButton" @click="showLogin">
    <div :class="useType.style===1?'circle-blue':'circle-orange'">
      <img :src="useType.logo" alt="按钮图标">
      <p>{{ useType.title }}</p>
    </div>
    <div>
      <transition name="fade">
        <div v-if="isShowSubButton" class="subbutton">
          <nav-subbutton :types="useSubTypes" />
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import NavSubButton from './NavSubButton'
export default {
  components: { 'nav-subbutton': NavSubButton },
  props: {
    functionId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      isShowSubButton: false,
      useSubTypes: [],
      useType: {},
      img: '../../../static/images/buttonicon1.png',
      types: [
        {
          id: 1,
          title: '行业新闻',
          style: 1,
          logo: require('../../../static/images/buttonicon1.png'),
          subTypes: [
            { title: '时政新闻', logo: require('../../../static/images/buttonicon1.png'), url: 'http://www.lyly360.com/news/newsIndex.htm?type=1' },
            { title: '行业新闻', logo: require('../../../static/images/buttonicon1.png'), url: 'http://www.lyly360.com/news/newsIndex.htm?type=2' },
            { title: '关于良医', logo: require('../../../static/images/buttonicon1.png'), url: 'http://www.lyly360.com/about.htm' }
          ]
        },
        {
          id: 2,
          title: '连锁诊所',
          style: 1,
          logo: require('../../../static/images/buttonicon2.png'),
          subTypes: [
            { title: '诊所软件', logo: require('../../../static/images/buttonicon2.png'), url: 'http://www.lyly360.com/hom/zsrj.htm' },
            { title: '良医诊所', logo: require('../../../static/images/buttonicon2.png'), url: 'http://www.lyly360.com/hom/lyzs.htm' },
            { title: '良医加盟', logo: require('../../../static/images/buttonicon2.png'), url: 'http://www.lyly360.com/hom/lyjm.htm' }
          ]
        },
        { id: 3, title: '报货平台', style: 2, logo: require('../../../static/images/buttonicon6.png') },
        {
          id: 4,
          title: '在线教育',
          style: 1,
          logo: require('../../../static/images/buttonicon3.png'),
          subTypes: [
            { title: '教育学院', logo: require('../../../static/images/buttonicon3.png'), url: 'http://www.lyly360.com/hom/jyxy.htm' },
            { title: '在线培训', logo: require('../../../static/images/buttonicon3.png'), url: 'http://www.lyly360.com/hom/zxpx.htm' },
            { title: '医药百科', logo: require('../../../static/images/buttonicon3.png'), url: 'http://www.lyly360.com/hom/yybk.htm' }
          ]
        },
        {
          id: 5,
          title: '医师药师',
          style: 1,
          logo: require('../../../static/images/buttonicon4.png'),
          subTypes: [
            { title: '医师问诊', logo: require('../../../static/images/buttonicon4.png'), url: 'http://www.lyly360.com/hom/yswz.htm' },
            { title: '药师问药', logo: require('../../../static/images/buttonicon4.png'), url: 'http://www.lyly360.com/hom/yswy.htm' },
            { title: '名医分享', logo: require('../../../static/images/buttonicon4.png'), url: 'http://www.lyly360.com/hom/myfx.htm' }
          ]
        },
        {
          id: 6,
          title: '保险金融',
          style: 1,
          logo: require('../../../static/images/buttonicon5.png'),
          subTypes: [
            { title: '金融服务', logo: require('../../../static/images/buttonicon5.png'), url: 'http://www.lyly360.com/hom/jrfw.htm' },
            { title: '购买保险', logo: require('../../../static/images/buttonicon5.png'), url: 'http://www.lyly360.com/hom/gmbx.htm' },
            { title: '保险介绍', logo: require('../../../static/images/buttonicon5.png'), url: 'http://www.lyly360.com/hom/bxjs.htm' }
          ]
        }
      ]
    }
  },
  mounted () {
    this.isShowSubButton = false
    this.useSubTypes = []
    this.getType()
  },
  methods: {
    showSubButton () {
      if (this.useType.style === 1) {
        this.isShowSubButton = true
      }
    },
    closeSubButton () {
      if (this.useType.style === 1) {
        this.isShowSubButton = false
      }
    },
    showLogin () {
      if (this.useType.style === 2) {
        this.$emit('showlogin')
      }
    },
    getType () {
      // 根据传入的参数获取当前显示的类型
      this.types.forEach(type => {
        if (this.functionId === type.id) {
          this.useType = type
          if (type.subTypes !== undefined && type.subTypes !== null) {
            type.subTypes.forEach(subType => {
              this.useSubTypes.push(subType)
            })
          }
        }
      })
    }
  }
}
</script>
<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
.circle-orange {
  width: 126px;
  height: 126px;
  background-image: url('../../../static/images/buttonstyle2.png');
}
.circle-orange img {
   margin-left: -5px;
  margin-top: 15px;
  width: 35px;
  height: 35px;
}
.circle-orange p {
  font-size: 20px;
  color: #ffffff;
  font-weight: 800;
   margin-left: -5px;
  margin-top: 5px;
}
.circle-blue {
  width: 126px;
  height: 126px;
  background-image: url('../../../static/images/buttonstyle1.png');
}
.circle-blue img {
  margin-left: -5px;
  width: 35px;
  height: 35px;
  margin-top: 15px;
}
.circle-blue p {
  margin-left: -5px;
  margin-top: 5px;
  font-size: 20px;
  color: #ffffff;
  font-weight: 800;
}
.subbutton {
  position: absolute;
  z-index: 9999;
}
</style>
